import { render, staticRenderFns } from "./PromoAdmin.vue?vue&type=template&id=1523a916"
import script from "./PromoAdmin.vue?vue&type=script&lang=js"
export * from "./PromoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports